import axios from './axios';
import config from '../../helpers/config';

export default (designId, itemId, width, height) => (
  axios.post(
    `${config.designBuilderEditMeasurementsPath}/${designId}/items/${itemId}/measurements`,
    { Width: width, Height: height },
  )
);
